module.exports = __webpack_public_path__ + "img/cnr.500351df.png";